import { MobileFolioActionTypes, MobileFoliosActionUnion } from './mobilefolio.actions';
import { adapter, initialState, MobileFolioState, selectMobileFolioIdFrom } from './mobilefolio.state';

export function mobileFolioReducer(
  state: MobileFolioState = initialState,
  action: MobileFoliosActionUnion
): MobileFolioState {
  switch (action.type) {
    case MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIOS_LOADED:
    case MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIO_UPDATED:
      if (action.payload.mobileFolio) {
        return adapter.upsertOne(action.payload.mobileFolio, state);
      } else {
        return state;
      }
    case MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIO_DELETED:
      return adapter.removeOne(selectMobileFolioIdFrom(action.payload.mobileFolio), state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectMobileFolioIds = selectIds;

export const selectMobileFolioEntities = selectEntities;

export const selectAllMobileFolios = selectAll;
